<template>
  <div>
    <CHeader style="height: 8vh;">
      <CButton variant="ghost" class="d-lg-none" @click=toggleSidebar>
        <CIcon :icon="cilMenu" size="xl" />
      </CButton>
      <CButton variant="ghost" class="d-none d-lg-block" @click=toggleSidebar>
        <CIcon :icon="cilMenu" size="xl" />
      </CButton>
      <CHeaderBrand class="mx-auto d-lg-none" src="/img/logo.png" width="190" height="46" alt="CoreUI Logo" />
      <CHeaderNav class="d-md-down-none me-auto">
        <CNavItem class="px-3">
          <CNavLink to="/">
            {{ systemName }}
          </CNavLink>
        </CNavItem>
      </CHeaderNav>
      <CHeaderNav class="me-4">
        <HeaderAccount />
      </CHeaderNav>
    </CHeader>
    <CHeader style="height: 8vh;">
      <CBreadcrumb class="border-0 ms-3">
        <CBreadcrumbItem v-for="(item, index) in breadcrumbItems" :key="index">
          <router-link style="text-decoration: none;" v-if="index !== breadcrumbItems.length - 1" :to="item.to">
            {{ item.text }}
          </router-link>
          <span v-else>
            {{ item.text }}
          </span>
        </CBreadcrumbItem>
      </CBreadcrumb>
    </CHeader>
  </div>
</template>

<script>
import HeaderAccount from './HeaderAccount'
import { Portal } from '@/helpers/constants'
import CIcon from '@coreui/icons-vue';
import { cilMenu } from '@coreui/icons'
import { CBreadcrumb, CBreadcrumbItem, CButton, CHeader, CHeaderBrand, CHeaderNav, CNavItem, CNavLink } from "@coreui/vue"
import { emitter } from '../../helpers/emitter';

export default {
  name: 'Header',
  components: {
    CHeader,
    CHeaderBrand,
    CHeaderNav,
    CNavItem,
    CNavLink,
    HeaderAccount,
    CBreadcrumb,
    CBreadcrumbItem,
    CIcon,
    CButton
  },
  data() {
    return {
      cilMenu,
      breadcrumbItems: [],
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.breadcrumbItems = to.matched
          .filter(i => i.name)
          .map(i => {
            let path = i.redirect || i.path

            if (path && !path.startsWith('/')) {
              path = '/' + path
            }

            return {
              text: i.name,
              to: path
            }
          })
      }
    }
  },
  computed: {
    systemName() {
      if (localStorage.path == Portal.INTERNAL) {
        return "Admin Console"
      } else if (localStorage.path == Portal.ISSUER) {
        return "Issuer Portal"
      } else if (localStorage.path == Portal.MERCHANT) {
        return "Token Requestor Portal"
      } else {
        return ""
      }
    },
  },
  methods: {
    toggleSidebar() {
      emitter.emit('toggle-sidebar')  // <-- triggers Sidebar listener
    },
  }
}
</script>
